interface MediaSource {
    url?: string;
    playURL?: string;
    thumb?: string;
}

export function getPlayableUrl(sources: MediaSource[]): string | null {
    // Priority 1: Video files (MP4, MOV)
    let files = sources.filter((e) =>
        (e.url && (e.url.toLowerCase().endsWith("mp4") ||
            e.url.toLowerCase().endsWith("wav") ||
            e.url.toLowerCase().endsWith("mov"))) ||
        (e.playURL && e.playURL.toLowerCase().endsWith("mp4"))
    );
    if (files && files.length > 0) {
        return files[0].url || files[0].playURL || null;
    }

    // Priority 2: Audio files (MP3, WAV, M4A, MPGA)
    files = sources.filter((e) =>
        (e.url && (e.url.toLowerCase().endsWith("mp3") ||
            e.url.toLowerCase().endsWith("wav") ||
            e.url.toLowerCase().endsWith("m4a") ||
            e.url.toLowerCase().endsWith("mp4") ||
            e.url.toLowerCase().endsWith("mpga"))) ||
        (e.playURL && e.playURL.toLowerCase().endsWith("m4a"))
    );
    if (files && files.length > 0) {
        return files[0].url || files[0].playURL || null;
    }

    return null;
}

export function isVideoUrl(url: string): boolean {
    const lower = url.toLowerCase();
    return lower.endsWith("mp4") || lower.endsWith("mov");
}
